// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var scrollbarStyles = css({
  msOverflowStyle: '-ms-autohiding-scrollbar',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  '&::-webkit-scrollbar-corner': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  '&::-webkit-scrollbar-thumb': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
    borderRadius: "var(--ds-radius-large, 8px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: "var(--ds-background-neutral-bold-hovered, #3B3D42)"
  }
});